<template>
    <div>
        <el-dialog title="修改产品"  v-model="dialogFormVisible" width="90%" top="5%">
            <el-form ref="formProduct" :model="formProduct" :rules="formProductRules">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="大类名" prop="productDetail_mtype" :label-width="formLabelWidth">
                            <el-select v-model="formProduct.productDetail_mtype" @change="handleSubType" placeholder="请选择">
                                <el-option
                                v-for="item in mType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="小类名" prop="productDetail_stype" :label-width="formLabelWidth">
                            <el-select v-model="formProduct.productDetail_stype" placeholder="请选择">
                                <el-option
                                v-for="item in sType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="8">
                        <el-form-item label="产品名称" prop="productDetail_name" :label-width="formLabelWidth">
                            <el-input v-model="formProduct.productDetail_name"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="8">
                        <el-form-item label="产品状态" prop="productDetail_status" :label-width="formLabelWidth">
                            <el-select v-model="formProduct.productDetail_status" placeholder="请选择">
                                <el-option
                                v-for="item in status"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="8">
                        <el-tooltip class="item" effect="dark" content="0:默认不展示在首页，1-6：为展示在首页产品（如果同样的数字，最靠近1为优先）" placement="top-start">
                                <pfInfoFilled style="float: inline-end;width: 1em; height: 1em; margin: 8px 0 0 8px; "></pfInfoFilled>
                        </el-tooltip>
                        <el-form-item label="展示位置" prop="isShow" :label-width="formLabelWidth">
                            <el-input v-model="formProduct.isShow"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="8">
                        <el-form-item label="产品语言" prop="lang" :label-width="formLabelWidth">
                            <el-select v-model="formProduct.lang" placeholder="请选择">
                                <el-option
                                v-for="item in lang"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="产品图片" prop="attchs" :label-width="formLabelWidth">
                            <span v-for="( item, index ) in formProduct.attchs" :key="item" class="removeImage" :style="spanleft(index)">
                                <pfDelete @click="handleRemoveImage(item)" style="width: 1em; height: 1em; margin-right: 8px" />
                            </span>
                            <el-upload
                                class="avatar-uploader" 
                                :show-file-list="false"
                                :on-progress="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                >
                                <span v-for="( item, index ) in formProduct.attchs" :key="item">
                                    <el-image v-if="item" style="width: 100px; height: 100px" :src="this.tempPicUrl[index]" class="avatar" />
                                </span>
                                <el-icon v-if="formProduct.attchs.length < 3" class="avatar-uploader-icon"><pfPlus /></el-icon>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <div>（如果上传图片出错[网络原因]请重新刷新，再次录入。）</div>
                    </el-col>
                    <!-- <el-col :span="24">
                        <el-form-item label="备注" prop="productDetail_Remark" :label-width="formLabelWidth">
                            <el-input v-model="formProduct.productDetail_Remark"  type="textarea" :rows="2"></el-input>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <el-tabs
                    v-model="formProduct.productDetail_typeNumberName"
                    type="border-card"
                    class="demo-tabs1"
                    v-show="false"
                    @tab-click="handleClick"
                >
                    <el-tab-pane label="属性一" :name=0>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="官能度" prop="productDetail_functionality" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_functionality"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="APHA No. (max.)" prop="productDetail_APHANO" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_APHANO"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="羟值 (mgKOH/g)" prop="productDetail_hydroxyl_value" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_hydroxyl_value"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="分子量 (Avg.)" prop="productDetail_MW" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_MW"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="水份 (%, max.)" prop="productDetail_watercontent" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_watercontent"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="粘度 (cps,25℃)" prop="productDetail_vicosity" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_vicosity"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="钾&钠离子 (ppm,max.)" prop="productDetail_NaK" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_NaK"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="固含量 (%, avg.)" prop="ProductDetail_Solid" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_Solid"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="应用" prop="productDetail_Application" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_Application"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="CP" prop="productDetail_CP" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_CP"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="EO" prop="ProductDetail_EO" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_EO"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="属性二" :name=1>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="属性名" prop="productDetail_Properties" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_Properties"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="单位" prop="productDetail_Unit" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_CP"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="销售规格" prop="productDetail_sales_specification" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_sales_specification"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="典型值" prop="productDetail_typical_value" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_typical_value"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="测试方法" prop="productDetail_test_method" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_test_method"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="属性三" :name=2>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="适用密度范围" prop="productDetail_density_range" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_density_range"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="稳泡能力" prop="productDetail_stabilizing_porency" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_stabilizing_porency"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="泡孔结构" prop="productDetail_cell_structure" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_cell_structure"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="加工宽容度" prop="productDetail_processing_latitude" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_processing_latitude"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="低挥发" prop="productDetail_low_VOC" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_low_VOC"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="水解稳定性" prop="productDetail_sensitive_to_hydrolysis" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_sensitive_to_hydrolysis"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="阻燃性能" prop="ProductDetail_FR_property" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.ProductDetail_low_VOC"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="低挥发" prop="productDetail_low_VOC" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_low_VOC"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="属性四" :name=3>
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="炼油 Banner （异构）" prop="productDetail_refinery_banner" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_refinery_banner"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="炼油 Inovyn（异构）" prop="productDetail_refinery_inovyn" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_refinery_inovyn"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="炼油 AGC(I grade)（重整）" prop="productDetail_refinery_AGC" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_refinery_AGC"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="清洗 AGC(S grade)" prop="productDetail_washing_AGC_S" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_washing_AGC_S"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="清洗 AGC(M grade)" prop="productDetail_washing_AGC_M" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_washing_AGC_M"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="制冷 AGC(S grade)" prop="productDetail_washing_AGC_Cooling_S" :label-width="formTypeNumberLabelTypeWidth">
                                    <el-input v-model="formProduct.productDetail_washing_AGC_Cooling_S"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
            <div class="dialog-footer">
                <el-button @click="closedDialog">取 消</el-button>
                <el-button type="primary" @click="submitForm()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from '@/api/api'
import cxf from '@/utils/GeneralFn'
import { Plus, Delete } from '@element-plus/icons-vue'
    export default {
        name: "modifyProductDialog",
        components: { 
            "pfPlus": Plus,
            "pfDelete": Delete,
            // "pfInfoFilled": InfoFilled
         },
        data() {
            return {
                iconArr:{
                    "pfPlus":Plus
                },
                mType:cxf.getMainType(),
                sType:[],
                productFile:[],
                status:cxf.getProductStatus(),
                lang:cxf.getProductLang(),
                dialogFormVisible:false,
                formLabelWidth:100,
                formTypeNumberLabelTypeWidth:200,
                formProduct: {
                    status:"",
                    attchs: [],
                    typeNumberName:1,
                    lang:""
                },
                formProductRules:{
                    ProductDetail_mtype: [
                        { required: true, message: 'Please input main type', trigger: 'blur' },
                    ],
                    ProductDetail_stype: [
                        { required: true, message: 'Please input sub type', trigger: 'blur' },
                    ]
                },
                tempPicUrl:[]
            }
        },
        props:{
            isModifyProductShow:Boolean,
            currentProductDetial:Object,
            timekey:Number
        },
        created(){
        },
        methods:{
            closedDialog(){
                this.dialogFormVisible = false;
                this.$refs['formProduct'].resetFields();
                this.$emit('isModifyProductShow', false);
            },
            submitForm(){
                this.$refs['formProduct'].validate(( valid ) => {
                    if (valid) {
                        let _addFromData = new FormData();
                        const data = this.formProduct;
                        _addFromData.append("apiType", "fromData");
                        for (let item in data) {
                            if ( item === 'attchs') {
                                if (this.productFile.length !== 0 ){
                                    for (let d in this.productFile) {
                                        if(this.productFile[d] instanceof Blob){
                                            let ext = this.productFile[d].type.split('/')[1];
                                            _addFromData.append('file', new File([this.productFile[d]], 'filename.'+ext, {type: this.productFile[d].type, lastModified: Date.now()}));
                                        }else{
                                            _addFromData.append('file', this.productFile[d] );
                                        }
                                    }
                                }
                            } else {
                                if ( data[item] ) {
                                    switch ( item ) {
                                        case 'productDetail_mtype' : 
                                            console.log(data['productDetail_mtype']);
                                            if (data['productDetail_mtype'].length > 1 ) {
                                                _addFromData.append(item, cxf.getMainTypeValue(data['productDetail_mtype']) );
                                            } else {
                                                _addFromData.append(item, data['productDetail_mtype'] );
                                            }
                                            break;
                                        case 'productDetail_stype' : 
                                            var isMtype = data['productDetail_mtype'].length > 1;
                                            var isStype = data['productDetail_stype'].length > 1;
                                            var _tempMtype = "";
                                            var _tempStype = "";

                                            _tempMtype = !isMtype ? data['productDetail_mtype'] : cxf.getMainTypeValue(data['productDetail_mtype']);
                                            _tempStype = !isStype ? data['productDetail_stype'] : cxf.getSubTypeValue( _tempMtype , data['productDetail_stype']);
                                            _addFromData.append(item, _tempStype);
                                            _addFromData.append(item, data['productDetail_stype']);
                                            break;
                                        case 'productDetail_status' : 
                                            if ( typeof data[item] === "string" ) {
                                                _addFromData.append(item, cxf.getProductStatusValue(data[item]));
                                            } else {
                                                _addFromData.append(item, data[item]);
                                            }
                                            break;
                                        default:
                                            _addFromData.append(item, data[item]);
                                            break;
                                    }
                                }
                            }
                        }

                        api.postEditProduct( _addFromData ).then( res => {
                            if ( res.data.success) {
                                this.$message({
                                    message: '产品修改成功！',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    message: res.data.message,
                                    type: 'warning'
                                });
                            }
                            this.dialogFormVisible = false;
                            this.$refs['formProduct'].resetFields();
                            this.$emit('hanldeCurrentPage');
                        }).catch( () => {
                            this.$message({
                                message: '产品修改出错，请联系相关员！',
                                type: 'errow'
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            async handleAvatarSuccess( n ,file) {
                const _addFromData = new FormData();
                _addFromData.append("apiType", "fromData");
                _addFromData.append("file", file.raw)

                let _resImage = await api.postUploadImage( _addFromData );
                
                if ( _resImage.data.success ) {
                    let imageId = _resImage.data.data;
                    this.formProduct.attchs.push(imageId);
                    this.productFile.push(file.raw)
                    let _resimageUrl = await api.getSysFileInfoPreview( { id:imageId } );
                    if ( _resimageUrl.status ) {
                        this.tempPicUrl.push(window.URL.createObjectURL(new Blob([_resimageUrl.data])));
                    }
                    console.log(this.tempPicUrl);
                } else {
                    this.$message({
                        message: '图片录入出错，请联系相关员！',
                        type: 'errow'
                    })
                }
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            handleSubType( mid ) {
                this.sType = cxf.getSubType( mid );
            },
            handleRemoveImage ( n ) {
                this.formProduct.attchs = this.formProduct.attchs.filter( ( item, index ) => {
                    if (  item == n) {
                        this.productFile.splice(index, 1);
                    }
                    if ( item != n ) {
                        return item;
                    }
                });
            },
            async getImage( id ) {
                if (id) {
                    let _tempRes = await api.getSysFileInfoPreview({id: id});
                        if ( _tempRes.status === 200 ) {
                            this.productFile.push(_tempRes.data);
                            this.tempPicUrl.push(window.URL.createObjectURL(_tempRes.data));
                        } else {
                            return '--';
                        }
                } else {
                    return "无图片"
                }
                
            },
            spanleft( index ) {
                if ( index === 0 ) {
                    return "left:0px;"
                } else {
                    let _wt = index * 100 + index * 20;
                    return "left:" + _wt + "px;"
                }
            }
        },
        watch:{
            isModifyProductShow( newv ){
                this.dialogFormVisible = newv;
            },
            timekey( newv, oldv ){
                if (newv !== oldv && oldv !== "")
                this.dialogFormVisible = this.$props.isModifyProductShow;
            },
            currentProductDetial ( newv ) {
                this.formProduct = newv;
                this.productFile = [];
                let tempmType = typeof this.formProduct['productDetail_mtype'] === 'number' ? this.formProduct['productDetail_mtype'] : cxf.getMainTypeValue(this.formProduct['productDetail_mtype']);
                this.sType = cxf.getSubType( tempmType );
                
                this.formProduct.attchs.forEach( async item => {
                    await this.getImage( item );
                });
            }
        }
    }
</script>


<style scoped>
.avatar-uploader span,i {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 15px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  
.dialog-footer {
    padding-top:20px;
}

.el-tabs__content{
    height: 200px !important;
}
.removeImage{
    width: 100px;
    height: 30px;
    z-index: 2000 !important;
    position: absolute;
    top:0px;
    background: black;
    opacity: 0.5;
}
</style>